import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { MachineTypeActions } from 'redux/actions/settings/MachineTypeActions';
import { ManufacturerActions } from 'redux/actions/settings/ManufacturerActions';
import { ModalActions } from "redux/actions/ModalActions";
import { UnitActions } from 'redux/actions/settings/UnitActions';

import { TableColumn, Table, TableRow } from 'app/components/common/Table';
import { StoreModel } from 'models/StoreModel';
import { LoginUser } from 'models/LoginUser';
import { MachineType } from 'models/MachineType';
import { Manufacturer } from 'models/Manufacturer';
import { Unit } from 'models/Unit';
import { PageContentHeader } from 'app/components/common/PageContentHeader';
import { Translations } from 'models/Translations';
import Translator from 'app/components/common/Translator';

interface Props {
    fetchMachineTypes: typeof MachineTypeActions.fetchMachineTypes;
    fetchManufacturers: typeof ManufacturerActions.fetchManufacturers;
    fetchUnits: typeof UnitActions.fetchUnits;
    addMachineTypeForm: typeof ModalActions.showModal;
    addMachineType: typeof MachineTypeActions.addMachineType;
    editMachineTypeForm: typeof ModalActions.showModal;
    editMachineType: typeof MachineTypeActions.editMachineType;
    deleteMachineType: typeof MachineTypeActions.deleteMachineType
    loginUser: LoginUser;
    machineTypes: MachineType[];
    manufacturers: Manufacturer[];
    units: Unit[];
    translations: Translations;
}

class MachineTypes extends React.Component<Props> {

    componentDidMount() {
        if (this.loggedIn()) {
            if (!this.props.machineTypes) {
                this.props.fetchMachineTypes(this.props.loginUser.token);
            }
            if (!this.props.manufacturers) {
                this.props.fetchManufacturers(this.props.loginUser.token);
            }
            if (!this.props.units) {
                this.props.fetchUnits(this.props.loginUser.token);
            }
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.manufacturers && this.props.machineTypes && this.props.units
    }

    setMachineData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.machineTypes.forEach(machinetype => {
                data.push({
                    dataObject: {
                        id: machinetype.id,
                        name: machinetype.name,
                        manufacturer: machinetype.manufacturer,
                        serviceLifeUnit: machinetype.serviceLifeUnit ?? Unit.empty(),
                        archivedDate: machinetype.archivedDate
                    }
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Machine Type',
                accessor: 'name',
            },
            {
                header: 'Manufacturer',
                accessor: 'manufacturer',
            },
            {
                header: 'Service Life Unit',
                accessor: 'serviceLifeUnit',
            }
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Machine Types" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Machine Types" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addMachineType}
                        addFormAction={this.props.addMachineTypeForm}
                        addFormData={{
                            header: "Add a new MachineType",
                            formObject: MachineType.empty(),
                        }}
                        editAction={this.props.editMachineType}
                        editFormAction={this.props.editMachineTypeForm}
                        editFormData={{
                            header: "Edit MachineType",
                        }}
                        deleteAction={this.props.deleteMachineType}
                        selectConfigs={[
                            { divId: 'serviceLifeUnit', storeKey: 'units', filter: (u: object) => Unit.hasUsage(u as Unit, 'ServiceLife') },
                            // 1 = part-only manufacturer
                            { divId: 'manufacturer', filter: (m: object) => (m as Manufacturer).manufacturerType?.id !== 1 }
                        ]}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setMachineData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        machineTypes: state.machineTypes,
        manufacturers: state.manufacturers,
        units: state.units,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchMachineTypes: bindActionCreators(MachineTypeActions.fetchMachineTypes, dispatch),
        fetchManufacturers: bindActionCreators(ManufacturerActions.fetchManufacturers, dispatch),
        fetchUnits: bindActionCreators(UnitActions.fetchUnits, dispatch),
        addMachineType: bindActionCreators(MachineTypeActions.addMachineType, dispatch),
        addMachineTypeForm: bindActionCreators(ModalActions.showModal, dispatch),
        editMachineType: bindActionCreators(MachineTypeActions.editMachineType, dispatch),
        editMachineTypeForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteMachineType: bindActionCreators(MachineTypeActions.deleteMachineType, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MachineTypes);